import ImpersonatedSourceConnect from "./ImpersonatedSourceConnect";

export default ImpersonatedSourceConnect;
